var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.664 10.0442C12.114 10.4942 12.114 11.2141 11.664 11.664C11.4421 11.886 11.1481 12 10.8541 12C10.5602 12 10.2662 11.886 10.0442 11.664L6.00075 7.62055L1.95726 11.664C1.72928 11.886 1.44132 12 1.14736 12C0.853393 12 0.55943 11.886 0.337458 11.664C-0.112486 11.2141 -0.112486 10.4942 0.337458 10.0442L4.38095 6.00075L0.337458 1.95726C-0.112486 1.50731 -0.112486 0.787402 0.337458 0.337458C0.781402 -0.112486 1.50731 -0.112486 1.95726 0.337458L6.00075 4.38095L10.0442 0.337458C10.4942 -0.112486 11.2141 -0.112486 11.664 0.337458C12.114 0.781402 12.114 1.50731 11.664 1.95726L7.62055 6.00075L11.664 10.0442Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e2be005b5a84c76d51a453854b9e89cf.svg";
export { ForwardRef as ReactComponent };